<template>
  <div class="bg-gray-200 h-auto">
    <navigation></navigation>
    <div class="container px-4 py-10 mx-auto max-w-7xl">
      <div class="flex items-center justify-between mb-6">
        <div class="lg:w-1/2 w-full">
          <input
            v-model="search"
            @input="tableInputSearchHandler($event)"
            type="text"
            class="border border-gray-400 px-3 py-2 text-sm rounded-md lg:w-1/2 w-full"
            placeholder="Pencarian.."
          />
        </div>
        <zautocomplete
          v-if="
            profileData &&
              (profileData.type_user === 'Super Admin' ||
                profileData.type_user === 'Supervisor')
          "
          class="-mt-1 w-40"
          v-model="branchSelected"
          :data="branchOptions"
          placeholder="Pilih Cabang"
          @input="refreshData"
        >
        </zautocomplete>
      </div>
      <zloading v-show="loading"></zloading>
      <datatable
        :data="data.data"
        :columns="columns"
        :meta="data.meta"
        :PageNavHandler="pageNavHandler"
        :TableInputSearchHandler="tableInputSearchHandler"
      >
        <!-- Custom Field -->
        <template slot="total_transaction" slot-scope="props">
          {{ props.item.transaction.length }}
        </template>
        <template slot="total_omzet" slot-scope="props">
          {{
            "Rp" +
              formatPrice(
                props.item.transaction.reduce(
                  (total, num) =>
                    total +
                    parseInt(num.amount_paid !== null ? num.amount_paid : 0),
                  0
                )
              )
          }}
        </template>
        <!-- / End Custom Field -->
      </datatable>
    </div>
  </div>
</template>

<script>
import navigation from "@/components/navigation";
import datatable from "@/components/datatables/advance_table";
import zautocomplete from "@/components/zautocomplete";
import zloading from "@/components/zloading";
import { reactive, computed } from "@vue/composition-api";
import { useOrderAgenList } from "@/composables/report/useReport";
import { useBranches } from "@/composables/master/useMaster";
export default {
  components: {
    navigation,
    datatable,
    zautocomplete,
    zloading,
  },
  setup() {
    const profile =
      JSON.parse(window.localStorage.getItem("data-profile-jaskipin")) || {};
    const { data: branchesData } = useBranches();
    const listParams = reactive({
      page: 1,
      limit: 10,
      pagination: true,
      search: "",
      ...(profile && profile.type_user === "Master Agen"
        ? { master_agen: profile.id }
        : { branch: undefined }),
    });
    const listQuery = useOrderAgenList(computed(() => ({ ...listParams })));
    return {
      branchesData,
      listParams,
      oaqListData: listQuery.data,
      oaqListIsLoading: listQuery.isLoading,
      oaqListRefetch: listQuery.refetch,
    };
  },
  data() {
    return {
      /* Auth Token */
      /* Data List */
      dataSelected: [],
      dataSelectedType: "",
      columns: [
        {
          field: "fullname",
          label: "Nama Agen",
        },
        {
          field: "total_transaction",
          label: "Total Transaksi",
        },
        {
          field: "total_omzet",
          label: "Total Omzet",
        },
      ],
      /* Filter */
      /* Toggle Dialog */
      /* Form Value */
      /* Extra Data */
      branchSelected: "",
    };
  },
  computed: {
    profileData() {
      let profile = JSON.parse(
        window.localStorage.getItem("data-profile-jaskipin")
      );
      if (profile) {
        return profile;
      } else {
        return null;
      }
    },
    page: {
      get() {
        return this.listParams.page;
      },
      set(v) {
        this.listParams.page = v;
      },
    },
    limit: {
      get() {
        return this.listParams.limit;
      },
      set(v) {
        this.listParams.limit = v;
      },
    },
    search: {
      get() {
        return this.listParams.search;
      },
      set(v) {
        this.listParams.search = v;
      },
    },
    data() {
      return this.oaqListData || {};
    },
    loading() {
      return this.oaqListIsLoading && !this.oaqListData;
    },
    branchOptions() {
      const raw = this.branchesData;
      const arr = Array.isArray(raw) ? raw : raw && raw.data ? raw.data : [];
      return arr.map((item) => ({ label: item.city_name, value: item.id }));
    },
  },
  methods: {
    /*
     * Get Data Method
     */
    async getListData(page, limit) {
      if (typeof page === "number") this.listParams.page = page;
      if (typeof limit === "number") this.listParams.limit = limit;
      const t = this.profileData && this.profileData.type_user;
      if (t === "Master Agen") {
        /* master_agen sudah di-set di setup. */
      } else if (t === "Super Admin" || t === "Supervisor") {
        /* Bebas pilih cabang via dropdown. */
        this.listParams.branch =
          this.branchSelected && this.branchSelected.value
            ? this.branchSelected.value
            : undefined;
      } else {
        /* Non Super Admin/Supervisor — kunci ke branch profile login. */
        this.listParams.branch =
          (this.profileData && this.profileData.branch && this.profileData.branch._id) ||
          undefined;
      }
      await this.oaqListRefetch();
    },
    /*
     * Pagination Handler Function
     */
    pageNavHandler(type) {
      switch (type) {
        case "previous":
          this.page -= 1;
          this.getListData(this.page, this.limit);
          break;
        case "next":
          this.page += 1;
          this.getListData(this.page, this.limit);
          break;
      }
    },
    /*
     * Search Function
     */
    tableInputSearchHandler(event) {
      const value = event.target.value; // ambil value dari form input search

      if (value === "") {
        this.search = ""; // Mengkosongkan kembali state querynya
        this.getListData(this.page, this.limit);
      } else {
        this.search = value;
        this.getListData(1, this.limit); // Ketika Filter Search dilakukan tidak bisa jika diset pagenya diatas 1 kalau hasil recordnya gak lebih dari limit/10 record
      }
    },
    /* Helpers */
    formatPrice(number) {
      var rupiah = "";
      var angkarev = number
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
    formatDate(value) {
      let options = { year: "numeric", month: "long", day: "numeric" };
      let date = new Date(value).toLocaleString("id-ID", options);
      return date;
    },
    refreshData() {
      this.getListData(this.page, this.limit);
    },
  },
};
</script>
